import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createRocketbetCanonicalItems = () => [
    {
        id: 'welcome-deposit-bonus',
        promotion: {
            id: 'welcome-deposit-bonus',
            title: Verbiage.welcome_bonus,
            startDate: new Date('2026-01-01T00:00:00Z'),
            description: Verbiage.up_to_3000_bonus_on_your_first_3_deposits,
            buttonText: Verbiage.claim,
            url: '/casino/',
            banner: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus-detail.png'),
            action: true,
            footerText: Verbiage.rocketbet_promotions_footer_text_3000_welcome_bonus
        },
        surfaces: {},
        order: { promotions: 0 }
    },
    {
        id: 'afk-airport-security',
        promotion: {
            id: 'afk-airport-security',
            title: Verbiage.afk_airport_security,
            description: Verbiage.afk_airport_security_description,
            buttonText: Verbiage.play_now,
            url: '/p/nolimit-city/afk_airport_security/',
            conditionalUrl: {
                loggedInUrl: '/player/p/nolimit-city/afk_airport_security/',
                loggedOutUrl: '/p/nolimit-city/afk_airport_security/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/afk_airport_security/afk_airport_security_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/afk_airport_security/afk_airport_security_mobile.png'),
            startDate: new Date('2026-07-07T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/afk_airport_security/afk_airport_security_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/afk_airport_security/afk_airport_security_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 0 }
    },
    {
        id: 'aliens-among-us',
        promotion: {
            id: 'aliens-among-us',
            title: Verbiage.aliens_among_us,
            description: Verbiage.aliens_among_us_description,
            buttonText: Verbiage.play_now,
            url: '/p/hacksaw-gaming/aliens_among_us/',
            conditionalUrl: {
                loggedInUrl: '/player/p/hacksaw-gaming/aliens_among_us/',
                loggedOutUrl: '/p/hacksaw-gaming/aliens_among_us/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/aliens_among_us/aliens_among_us_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/aliens_among_us/aliens_among_us_mobile.png'),
            startDate: new Date('2026-07-02T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/aliens_among_us/aliens_among_us_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/aliens_among_us/aliens_among_us_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 1 }
    },
    {
        id: 'tournaments',
        promotion: {
            id: 'tournaments',
            title: Verbiage.weekly_races,
            description: Verbiage.weekly_races_description_2,
            buttonText: Verbiage.start_now,
            url: '/tournaments/#/tournaments/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_1500_every_week
        },
        topSection: {
            title: Verbiage.rocket_races,
            description: Verbiage.win_real_cash_prizes_every_week,
            backgroundImage: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_races,
            link: '/tournaments/#/tournaments/',
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 1, topSection: 1 }
    },
    {
        id: 'jackpot',
        promotion: {
            id: 'jackpot',
            title: Verbiage.rocket_jackpot_million_title,
            description: Verbiage.rocket_jackpot_million_description,
            buttonText: Verbiage.play_now,
            url: '/promotion-page/jackpot/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/jackpot/jackpot.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/jackpot/jackpot-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_all_caps
        },
        order: { promotions: 2 }
    },
    {
        id: 'raffles',
        promotion: {
            id: 'raffles',
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            buttonText: Verbiage.enter_now,
            url: '/tournaments/#/raffles/',
            startDate: new Date('2026-06-29T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/raffles/raffles.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_500_cash_prize
        },
        topSection: {
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/raffles/raffles_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/raffles/raffles_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_raffle,
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 3, topSection: 2 }
    },
    {
        id: 'weekly-prizes',
        promotion: {
            id: 'weekly-prizes',
            title: Verbiage.rocket_weekly_prizes_title,
            description: Verbiage.rocket_weekly_prizes_description,
            buttonText: Verbiage.join_now,
            url: '/promotion-page/weekly-prizes/',
            startDate: new Date('2026-03-04T18:01:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_daily_rewards
        },
        order: { promotions: 4 }
    },
    {
        id: 'rewards-program',
        promotion: {
            id: 'rewards-program',
            title: Verbiage.rewards_program,
            description: Verbiage.rewards_program_description,
            buttonText: Verbiage.more_info,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            customTitleWidth: '70%',
            banner: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_vip_galaxy
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            badgeText: Verbiage.exclusive
        },
        order: { promotions: 5, topSection: 3 }
    },
    {
        id: 'inner-circle-telegram',
        promotion: {
            id: 'inner-circle-telegram',
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            buttonText: Verbiage.join,
            url: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_exclusive_bonuses
        },
        topSection: {
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            badgeText: Verbiage.exclusive,
            buttonText: Verbiage.join,
            link: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z')
        },
        order: { promotions: 6, topSection: 4 }
    },
    {
        id: 'rakeboost-promo',
        promotion: {
            id: 'rakeboost-promo',
            title: Verbiage.rocket_rakeboost_promo_title,
            description: Verbiage.rocket_rakeboost_promo_description,
            buttonText: Verbiage.rocket_boost_up,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            banner: cfgToThemeCdnPath('/promotions/rakeboost_promo/rakeboost_promo.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_boost_your_rewards
        },
        order: { promotions: 7 }
    }
];
